<template>
  <v-textarea
    v-if="multiline"
    ref="field"
    v-bind="commonProps"
    auto-grow
    persistent-placeholder
    :filled="filled"
    @change="change"
    @input="update"
    @blur="blur($refs.field)"
    :hide-details="'auto'"
    :rows="rows"
  ></v-textarea>
  <v-text-field
    :class="prefix ? 'v-input--with-prefix' : ''"
    v-else
    ref="field"
    v-bind="commonProps"
    @change="change"
    @input="update"
    @blur="blur($refs.field)"
    :type="type"
    persistent-placeholder
    :disabled="disabled"
    :prefix="prefix"
    :suffix="suffix"
    :hide-details="'auto'"
    :validate-on-blur="validateOnBlur"
  >
    <template v-slot:label>
      {{ getLabel }}
      <span
        v-if="required"
        class="required__icon">
        <slot name="required-symbol">*</slot>
      </span>
      <slot name="info"></slot>
    </template>

    <template v-slot:append>
      <slot name="append"></slot>
    </template>
    <template v-slot:prepend-inner>
      <slot name="prepend-inner"></slot>
    </template>
  </v-text-field>
</template>

<script>
import Input from "../../../mixins/input";
import Editable from "../../../mixins/editable";

/**
 * Text editing for text value type via a basic text input.
 * Support textarea mode for long text via `multiline` prop.
 * Can be use for any date, datetime or time editing, use type set on `date`, `datetime-local` or `time`.
 * Render will depend of browser support.
 */
export default {
  mixins: [Input, Editable],
  props: {
    /**
     * Text to be edited.
     * @model
     */
    value: {
      type: String,
      default: "",
    },
    /**
     * Type of text input. All HTML type allowed.
     */
    type: {
      type: String,
      default: "text",
    },
    /**
     * Transform text input into textarea.
     */
    multiline: Boolean,
    /**
     * Use full filled background color style.
     */
    filled: {
      type: Boolean,
      default: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefix: {
      type: String,
      default: "",
    },
    suffix: {
      type: String,
      default: "",
    },
    /**
     * Rows for textarea
     */
    rows: {
      type: Number,
      default: 1,
    },
    validateOnBlur: {
      type: Boolean,
      default: false,
    },
    blur: {
      type: Function,
      default: () => {},
    },
  },
};
</script>
